<div class="acciones_print">
	<a (click)="buildReport('downloadPDF')" id="htmlData" class="btn_pdf"
		><img src="assets/images/icon_pdf.png" alt="Descargar PDF"
	/></a>
	<a (click)="buildReport('print')" class="btn_print"><img src="assets/images/icon_print.png" alt="Imprimir" /></a>
	<a (click)="buildReport('downloadXLS')" class="btn_xls"
		><img src="assets/images/icon_xls.png" alt="Descargar XLS"
	/></a>
</div>
